import { useState } from 'react';
import type { FormEvent } from 'react';

import { useSesion } from '../auth/sesion';
import { Aviso, Campo } from '../ui/piezas';

export default function Entrar() {
  const { entrar } = useSesion();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(evento: FormEvent) {
    evento.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      await entrar(email.trim(), password);
    } catch (e) {
      setError(e);
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="entrada">
      <form className="entrada__caja" onSubmit={(e) => void enviar(e)}>
        <div className="entrada__marca">
          <img src="/favicon.svg" alt="" width="44" height="44" />
          <span>Inmobiliaria La Cordillera</span>
        </div>

        <Aviso error={error} />

        <Campo
          etiqueta="Correo"
          tipo="email"
          valor={email}
          alCambiar={setEmail}
          requerido
          placeholder="tu@inmobiliariacordillera.com"
        />
        <div style={{ height: 12 }} />
        <Campo etiqueta="Contraseña" tipo="password" valor={password} alCambiar={setPassword} requerido />

        <div style={{ height: 20 }} />
        <button type="submit" style={{ width: '100%' }} disabled={enviando || !email || !password}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>

        {/*
          Todavía no hay «olvidé mi contraseña» (B-2 del roadmap): hoy la
          reinicia quien administra los usuarios. Decirlo aquí evita que alguien
          se quede tocando un enlace que no existe.
        */}
        <p className="campo__ayuda" style={{ marginTop: 16, textAlign: 'center' }}>
          ¿Olvidaste la contraseña? Pídele a quien administra los usuarios que la reinicie.
        </p>
      </form>
    </div>
  );
}
